import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CreditCardComponent } from './credit-card.component';
import { TransactionsListComponent } from './transactions-list.component';
import { AccountBalanceComponent } from './account-balance.component';
import { QuickTransferComponent } from './quick-transfer.component';
import { SpendingBreakdownComponent } from './spending-breakdown.component';

@Component({
  selector: 'app-fintech-dashboard',
  templateUrl: './fintech-dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CreditCardComponent,
    TransactionsListComponent,
    AccountBalanceComponent,
    QuickTransferComponent,
    SpendingBreakdownComponent
  ],
})
export class FintechDashboardComponent {}
